import { get, post } from "@/libs/http";
import { createApiQuery } from "@/hooks/use-api-query";
import type { HomeRes } from "@/types/api/gullak-cash/home";
import type { BalanceRes } from "@/types/api/gullak-cash/balance";
import type { ClaimRes } from "@/types/api/gullak-cash/claim";
import type { GullakTaskReq, GullakTaskRes } from "@/types/api/gullak-cash/gullak-task";
import type { CashHistoryReq, CashHistoryRes } from "@/types/api/gullak-cash/cash-history";
import type { VipRulesRes } from "@/types/api/gullak-cash/vip-rules";

/**
 * @description 存钱罐主页-未登录
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10243
 */
export const getGullakGuestHome = () => {
  return get<HomeRes>('/activity/gullak/v1/guestHome');
};

/**
 * @description 存钱罐主页
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10237
 */
export const getGullakHome = () => {
  return get<HomeRes>('/activity/gullak/v1/home');
};

/**
 * @description 存钱罐首页金额
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10213
 */
export const getGullakBalance = () => {
  return get<BalanceRes>('/activity/gullak/v1/balance');
};

/**
 * @description 存钱罐领取
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10231
 */
export const claimGullakCash = () => {
  return post<ClaimRes>('/activity/gullak/v1/claim');
};

/**
 * @description 存钱罐主页-任务列表
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10514
 */
export const getGullakTaskList = (params: GullakTaskReq) => {
  return get<GullakTaskRes>('/activity/gullak/v1/gullakTask', { params });
};

/**
 * @description 获取存钱罐的历史记录
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10219
 */
export const getGullakCashHistory = (params: CashHistoryReq) => {
  return get<CashHistoryRes>('/activity/gullak/v1/cashHistory', { params });
};

/**
 * @description 存钱罐Vip规则
 * @url http://yapi.cggame123.com:3001/project/116/interface/api/10225
 */
export const getGullakVipRules = () => {
  return get<VipRulesRes>('/activity/gullak/v1/vipRules');
};

// ==================== React Query Hooks ====================

/**
 * @description React Query Hook: 存钱罐主页-未登录
 */
const { useQueryHook: useGetGullakGuestHomeHook } = createApiQuery(
  getGullakGuestHome,
  () => ['gullak-cash', 'guest-home']
);
export const useGetGullakGuestHome = useGetGullakGuestHomeHook;

/**
 * @description React Query Hook: 存钱罐主页
 */
const { useQueryHook: useGetGullakHomeHook } = createApiQuery(
  getGullakHome,
  () => ['gullak-cash', 'home']
);
export const useGetGullakHome = useGetGullakHomeHook;

/**
 * @description React Query Hook: 存钱罐首页金额
 */
const { useQueryHook: useGetGullakBalanceHook } = createApiQuery(
  getGullakBalance,
  () => ['gullak-cash', 'balance']
);
export const useGetGullakBalance = useGetGullakBalanceHook;

/**
 * @description React Query Hook: 存钱罐主页-任务列表
 */
const { useQueryHook: useGetGullakTaskListHook } = createApiQuery(
  getGullakTaskList,
  (params) => ['gullak-cash', 'task-list', params.page, params.page_size]
);
export const useGetGullakTaskList = useGetGullakTaskListHook;

/**
 * @description React Query Hook: 获取存钱罐的历史记录
 */
const { useQueryHook: useGetGullakCashHistoryHook } = createApiQuery(
  getGullakCashHistory,
  (params) => ['gullak-cash', 'cash-history', params.operate, params.page, params.page_size]
);
export const useGetGullakCashHistory = useGetGullakCashHistoryHook;

/**
 * @description React Query Hook: 存钱罐Vip规则
 */
const { useQueryHook: useGetGullakVipRulesHook } = createApiQuery(
  getGullakVipRules,
  () => ['gullak-cash', 'vip-rules']
);
export const useGetGullakVipRules = useGetGullakVipRulesHook;
